export class GitDraft {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "branch",
            "baseName": "branch",
            "type": "string",
            "format": ""
        },
        {
            "name": "headSha",
            "baseName": "headSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "defaultHeadSha",
            "baseName": "defaultHeadSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "aheadBy",
            "baseName": "aheadBy",
            "type": "number",
            "format": ""
        },
        {
            "name": "behindBy",
            "baseName": "behindBy",
            "type": "number",
            "format": ""
        },
        {
            "name": "hasUnpublishedChanges",
            "baseName": "hasUnpublishedChanges",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "pullRequest",
            "baseName": "pullRequest",
            "type": "GitPullRequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitDraft.attributeTypeMap;
    }
    constructor() {
    }
}
